<template lang="pug">

  label(class="sosCheckbox" :class="{ 'sosCheckbox--checked': checked, 'sosCheckbox--disabled': disabled }" :for="id" :disabled="disabled")
    input(type="checkbox" :value="checked" @change="updateCheckbox" :id="id")
    span.sosCheckboxInner
    span(v-if="!!label" class="sosCheckboxLabel") {{ label }}

</template>

<script>

  export default {
    name: 'SosCheckbox',
    props: {
      disabled: {
        type: Boolean,
        default: () => false,
      },
      checked: {
        type: Boolean,
        default: () => false,
      },
      label: {
        type: String,
        default: () => '',
      },
      id: {
        type: String,
        required: true,
        default: () => '',
      },
    },

    methods: {
      updateCheckbox (event) {
        event.preventDefault()

        if (this.disabled) return false

        this.$emit('click')
      },
    },
  }

</script>

<style scoped lang="scss">

  .sosCheckbox {
    cursor: pointer;

    font-size: 0;

    input[type="checkbox"] {
      display: none;
    }

    .sosCheckboxInner {
      transition-property: background-color;
      transition-duration: 150ms;

      position: relative;

      display: inline-block;
      vertical-align: middle;
      width: 22px;
      height: 22px;
      border: 1px solid #e54245;
      border-radius: 3px;
      background-color: transparent;

      &::before,
      &::after {
        transition-property: background-color;
        transition-duration: 150ms;

        content: "";

        position: absolute;
        width: 2px;
        background-color: transparent;
      }

      &::before {
        top: 9px;
        left: 5px;

        height: 6px;
        transform: rotate(-45deg);
      }

      &::after {
        top: 4px;
        left: 11px;

        height: 12px;
        transform: rotate(40deg);
      }
    }

    .sosCheckboxLabel {
      display: inline-block;
      vertical-align: middle;
      padding-left: 4px;

      font-size: 16px;
      line-height: 20px;

      user-select: none;
    }

    &.sosCheckbox--checked {
      .sosCheckboxInner {
        background-color: #e54245;

        &:before,
        &:after {
          background-color: #FFFFFF;
        }
      }
    }

    &.sosCheckbox--disabled {
      cursor: not-allowed;

      .sosCheckboxInner {
        background-color: #DDDDDD;
        border: 1px solid #AAAAAA;
      }

      .sosCheckboxLabel {
        color: #888888;
      }

      &.sosCheckbox--checked {
        .sosCheckboxInner {
          &:before,
          &:after {
            background-color: #999999;
          }
        }
      }
    }
  }

</style>
